export const CACHE_BUST_QUERY_PARAM = 'bust'

export function getCacheBustSearchParams() {
    if (typeof window === 'undefined') {
        return ''
    }

    const bust = new URLSearchParams(window.location.search).get(
        CACHE_BUST_QUERY_PARAM
    )

    return bust ? `?${CACHE_BUST_QUERY_PARAM}=${encodeURIComponent(bust)}` : ''
}
